import { Input } from "../../../../components/ui/input"
import { DataTableViewOptions } from "./data-table-view-options"
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "../../../../components/ui/select"
import { useState } from "react"
import DataTablePreset from "./data-table-preset";
import { Label } from "../../../../components/ui/label";


export function DataTableToolbar({
    table,
    allJobs,
    preset,
    onPresetChange,
    onExportCSV
}) {
    const filterableColumns = table.getAllColumns().filter(col => col.getCanFilter());
    const [filterColumn, setFilterColumn] = useState(
        filterableColumns.length > 0 ? filterableColumns[0].id : ""
    );
    return (
        <div className="flex flex-col w-full gap-2">
            <DataTablePreset allJobs={allJobs} preset={preset} onPresetChange={onPresetChange} onExportCSV={onExportCSV} />
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                    <Select className="flex-none"
                        value={filterColumn}
                        onValueChange={(value) => {
                            setFilterColumn(value);
                            table.getColumn(value)?.setFilterValue("");
                            console.log("Selected column:", value);
                        }}
                    >
                        <SelectGroup>
                            <SelectLabel>Select field to apply search filter</SelectLabel>
                            <SelectTrigger className="h-8 w-[150px] truncate lg:w-[200px]">
                                <SelectValue placeholder="select field" />
                            </SelectTrigger>
                        </SelectGroup>
                        <SelectContent className="h-[calc(100dvh/2)] overflow-y-auto">
                            {table.getAllColumns().map((column) => (
                                <SelectItem key={column.id} value={column.id}>
                                    {column.id}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                    <div>
                        <Label htmlFor='search-filter'>Search in slected field</Label>
                        <Input
                            id='search-filter'
                            placeholder="Filter tasks..."
                            value={(table.getColumn(filterColumn)?.getFilterValue()) ?? ""}
                            onChange={(event) =>
                                table.getColumn(filterColumn)?.setFilterValue(event.target.value)
                            }
                            className="h-8  flex-1 w-[150px] lg:w-[250px]"
                        />
                    </div>
                </div>
                <DataTableViewOptions table={table} />
            </div>
        </div>
    )
}